(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lcc-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-lcc-shop]').forEach(link=>{const grid=document.querySelector('[id$="__product_list_EDUBdR"]');if(grid){grid.id='lcc-cookie-lineup';link.href='#lcc-cookie-lineup';}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcc-social"] && !Shopify.designMode) return;
  try {
    
function setupCookieVideos(root){
root.querySelectorAll('.lcc-social').forEach(section=>{
if(section.dataset.ready)return;section.dataset.ready='true';
const track=section.querySelector('.lcc-video-track');
section.querySelectorAll('[data-lcc-direction]').forEach(button=>button.addEventListener('click',()=>{
if(track)track.scrollBy({left:Number(button.dataset.lccDirection)*302,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
}));
const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
let inView=false;
let paused=false;
let focusInside=false;
if(track&&track.scrollWidth>track.clientWidth){
const autoAdvance=()=>{
if(!inView||paused||focusInside||document.hidden||reducedMotion.matches)return;
const maxScroll=track.scrollWidth-track.clientWidth;
const next=track.scrollLeft+302;
track.scrollTo({left:next>=maxScroll-4?0:next,behavior:'smooth'});
};
const observer=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting},{threshold:0.2});
observer.observe(section);
section.addEventListener('mouseenter',()=>{paused=true});
section.addEventListener('mouseleave',()=>{paused=false});
section.addEventListener('focusin',()=>{focusInside=true});
section.addEventListener('focusout',()=>{focusInside=section.contains(document.activeElement)});
window.setInterval(autoAdvance,4500);
}
section.querySelectorAll('[data-lcc-video]').forEach(button=>button.addEventListener('click',()=>{
let url;try{url=new URL(button.dataset.lccVideo)}catch{return}
if(!['www.tiktok.com','tiktok.com'].includes(url.hostname))return;
const match=url.pathname.match(/^\/@[^/]+\/video\/(\d+)\/?$/);if(!match)return;
const frame=document.createElement('iframe');frame.src='https://www.tiktok.com/player/v1/'+match[1]+'?autoplay=0&controls=1&rel=0';frame.title=button.getAttribute('aria-label');frame.allow='fullscreen';frame.setAttribute('allowfullscreen','');button.replaceWith(frame);
}));
});
}
setupCookieVideos(document);
document.addEventListener('shopify:section:load',event=>setupCookieVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
